import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable ,  forkJoin } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable()
export class GestionOrService {

    constructor(private http: HttpClient) {
    }

    requestData(params1, params2): Observable<any[]> {

        const response1 = this.http.post(`${environment.ENTORNO}Services/Workshop/RepairOrderService.svc/GetByProductionOrderNumberComplete`, params1);
        const response2 = this.http.post(`${environment.ENTORNO}Services/General/EmployeeSigningService.svc/GetRunningAppointmentsForRepairOrder`, params2);

        return forkJoin([response1, response2]);
    }


    getPaymentTypes(url, params) {
        return this.http.post<any>(url, params);
    }

    refresData(params): Observable<any[]> {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/RepairOrderService.svc/GetByProductionOrderNumberComplete`;
        const response1 = this.http.post(_URL_, params);
        return forkJoin([response1]);
    }

    getDataOrders(url, params) {
        return this.http.post<any>(url, params);
    }

    getAseguradoras(url, params) {
        return this.http.post<any>(url, params);
    }

    getForfaits(url, params) {
        return this.http.post<any>(url, params);
    }

    getStateList(url: string, params: object) {

        return this.http.post<any>(url, params);
    }

    getRunningAppointmentsForRepairOrder(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    getAllImputationTypes(url, params) {
        return this.http.post<any>(url, params);
    }

    getByCustomerCodeWithContacts(url, params) {
        return this.http.post<any>(url, params);
    }

    getProductivity(url, params) {
        return this.http.post<any>(url, params);
    }

    getAllWorkingSections(url, params) {
        return this.http.post<any>(url, params);
    }

    interventionTypesService(url, params) {
        return this.http.post<any>(url, params);
    }

    internalSectionsService(url, params) {
        return this.http.post<any>(url, params);
    }

    orderSubTypes(url, params) {
        return this.http.post<any>(url, params);
    }

    anularLinea(url, params) {
        return this.http.post<any>(url, params);
    }

    getProductionOrderDetailsView(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    productionOrderValuation(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    addReceptionLineToRepairOrder(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    acctionToRepairOrder(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    cancelProductionOrder(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    reopenProductionOrder(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    reopenProductionOrderLines(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    receptionistAll(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    saveDatatAll(url: string, params: object) {
        return this.http.post<any>(url, params);
    }
    validateFiscalCode(url: string, params: object) {
        return this.http.post<any>(url, params);
    }
    existsByFiscalCode(url: string, params: object) {
        return this.http.post<any>(url, params);
    }
    closeProductionOrderLines(url: string, params: object) {
        return this.http.post<any>(url, params);
    }

    updateProductionOrderHeader(url: string, params: object) {
        return this.http.post<any>(url, params);
    }
}
